export enum CONFIRMATION_TYPE {
  FOUND = 'rx_found',
  NO_RX = 'no_rx_requested',
  NOT_FOUND = 'no_rx_found',
  PROCESSING = 'rx_processing',
  TRANSFER = 'rx_requested',
}

export enum SUBHEADER {
  FOUND = 'Your prescriptions are ready',
  NO_RX = 'Here’s how to add prescriptions to your account',
  NOT_FOUND = 'Your account has been created',
  PROCESSING = 'Your prescription is almost ready',
  TRANSFER = '',
}

export enum VERSION {
  FOUND = 'FOUND',
  NO_RX = 'NO_RX',
  NOT_FOUND = 'NOT_FOUND',
  PROCESSING = 'PROCESSING',
  TRANSFER = 'TRANSFER',
}
